<template>
  <div class="scpPage">
    <!-- <div class="secondOperation">
      <i-button @click="getAllData">
        <i class="iconfont icon-refresh"></i>
        刷新
      </i-button>
      <div class="status">{{ result.serviceStatus == 10 ? '启 用' : result.serviceStatus == 11 ? '启 用 中' :
        result.serviceStatus == 21 ? '禁 用 中' : '禁 用' }}</div>
    </div> -->
    <!-- <div class="first">
      <div class="tit">
        <div class="line"></div>影像归档服务基本信息
      </div>
      <div style="display: flex;justify-content: space-between;">
        <div class="log" @click="showLog = true">查看日志</div><i-switch v-model="isOpen" @on-change="changeSwitch"
          size="small" style="margin: 8px 0 0 0;"></i-switch>
      </div>
    </div> -->
    <!-- <div class="des">
      <div class="serDes"><span class="secondTit">服务描述：</span>{{ result.description }}</div>
      <div><span class="secondTit">更新时间：</span>{{ result.createTime }}</div>
    </div> -->
    <!-- <div class="first">
        <div class="tit">
          <div class="line"></div>基础配置
        </div>
      </div>
      <div class="des">

        <Form :label-width="120" inline>
          <FormItem label="一轮休眠时长">
            <Input class='publicInput' placeholder="请输入" 
            type="number" v-model="baseData.Interval" clearable></Input>
          </FormItem>
          <FormItem label="是否打印SQL">
            <Radio-group class='publicInput' v-model="baseData.isPrintSql">
              <Radio :label="1">是</Radio>
              <Radio :label="0">否</Radio>
            </Radio-group>
          </FormItem>
          <FormItem label="日志级别">
            <Select class='publicInput' v-model="baseData.LogLevel" style="width:200px">
              <Option v-for="item in LogsData" :value="item.key" :key="item.key">{{ item.value }}</Option>
            </Select>
          </FormItem>

        </Form>
        <Button class="ml-5 mr-5" type="primary" @click="updateArchBaseConfig">确定</Button>
        <Button @click="cancelEdit">取消</Button>
        <div>

        </div>
      </div> -->

    <div class="second">
      <div class="tit">
        <div class="line"></div>
        影像归档服务参数配置
      </div>
      <div class="service"><span class="point"></span> 服务1</div>
      <div class="secOperation">
        <Form :label-width="150" inline>
          <div class="serverTop">
            <div class="top Serverdiv">
              <div>
                <i-button @click="getData1">
                  <i class="iconfont icon-refresh"></i>
                  刷新
                </i-button>
                <i-button
                  @click="showLog = true"
                  style="margin-left: 15px"
                  type="primary"
                >
                  查看日志
                </i-button>
              </div>
              <div style="display: flex; align-items: center">
                <i-switch
                  v-model="isOpen"
                  @on-change="changeSwitch"
                  size="small"
                  style="margin: 8px 20px 0 0px"
                ></i-switch>
                <div class="status">
                  {{
                    result.serviceStatus == 10
                      ? "启 用"
                      : result.serviceStatus == 11
                      ? "启 用 中"
                      : result.serviceStatus == 21
                      ? "禁 用 中"
                      : "禁 用"
                  }}
                </div>
              </div>
            </div>
            <div class="bottom Serverdiv">
              <div></div>
              <!-- <div style="" class="right">
                <div class="log" @click="showLog = true">查看日志</div><i-switch v-model="isOpen" @on-change="changeSwitch"
                  size="small" style="margin: 8px 0 0 0;"></i-switch>
              </div> -->
            </div>
          </div>
          <FormItem label="每次查询数据量">
            <InputNumber
              :min="0"
              placeholder="每次查询数据量"
              v-model="params1.SearchMax"
              clearable
            ></InputNumber>
          </FormItem>
          <FormItem :label-width="150" label="影像存储路径">
            <Input
              class="publicInput"
              placeholder="影像存储路径"
              v-model="params1.ImageSavePath"
              clearable
            ></Input>
          </FormItem>
          <FormItem label="Redis">
            <Select
              class="publicInput"
              v-model="params1.redisIndex"
              style="width: 180px"
            >
              <Option v-for="item in redisPrice" :value="item" :key="item">{{
                item
              }}</Option>
            </Select>
          </FormItem>
          <FormItem :label-width="150" label="一轮休眠时长(秒)">
            <InputNumber
              :min="0"
              placeholder="请输入"
              type="number"
              v-model="params1.Interval"
              clearable
            ></InputNumber>
          </FormItem>
          <FormItem label="是否打印SQL">
            <Radio-group class="publicInput" v-model="params1.isPrintSql">
              <Radio :label="1">是</Radio>
              <Radio :label="0">否</Radio>
            </Radio-group>
          </FormItem>
          <FormItem :label-width="150" label="日志级别">
            <Select
              class="publicInput"
              v-model="params1.LogLevel"
              style="width: 180px"
            >
              <Option
                v-for="item in LogsData"
                :value="item.key"
                :key="item.key"
                >{{ item.value }}</Option
              >
            </Select>
          </FormItem>
        </Form>
        <div class="btnGroup">
          <Button class="cancel" @click="getData1()">重置</Button>
          <Button type="primary" @click="saveData1()">保存</Button>
        </div>
      </div>
      <div class="service"><span class="point"></span> 服务2</div>
      <div class="secOperation">
        <Form :label-width="150" inline>
          <div class="serverTop">
            <div class="top Serverdiv">
              <div>
                <i-button @click="getData2">
                  <i class="iconfont icon-refresh"></i>
                  刷新
                </i-button>
                <i-button
                  @click="showLog = true"
                  style="margin-left: 15px"
                  type="primary"
                >
                  查看日志
                </i-button>
              </div>
              <div style="display: flex; align-items: center">
                <i-switch
                  v-model="isOpen1"
                  @on-change="changeSwitch1"
                  size="small"
                  style="margin: 8px 20px 0 0px"
                ></i-switch>
                <div class="status">
                  {{
                    result1.serviceStatus == 10
                      ? "启 用"
                      : result1.serviceStatus == 11
                      ? "启 用 中"
                      : result1.serviceStatus == 21
                      ? "禁 用 中"
                      : "禁 用"
                  }}
                </div>
              </div>
            </div>
            <div class="bottom Serverdiv">
              <div></div>
              <!-- <div style="" class="right">
                <div class="log" @click="showLog = true">查看日志</div>
                <i-switch
                  v-model="isOpen1"
                  @on-change="changeSwitch1"
                  size="small"
                  style="margin: 8px 0 0 0"
                ></i-switch>
              </div> -->
            </div>
          </div>

          <FormItem label="每次查询数据量">
            <InputNumber
              :min="0"
              placeholder="每次查询数据量"
              v-model="params2.SearchMax"
              clearable
            ></InputNumber>
          </FormItem>
          <FormItem :label-width="150" label="影像存储路径">
            <Input
              class="publicInput"
              placeholder="影像存储路径"
              v-model="params2.ImageSavePath"
              clearable
            ></Input>
          </FormItem>
          <FormItem label="Redis主库">
            <Select
              class="publicInput"
              v-model="params2.redisIndex"
              style="width: 180px"
            >
              <Option v-for="item in redisPrice" :value="item" :key="item">{{
                item
              }}</Option>
            </Select>
          </FormItem>
          <FormItem label="Redis明细库">
            <Select class="publicInput" v-model="params2.redisIndex2">
              <Option v-for="item in redisPrice" :value="item" :key="item">{{
                item
              }}</Option>
            </Select>
          </FormItem>
          <FormItem label="一轮休眠时长(秒)">
            <InputNumber
              :min="0"
              placeholder="请输入"
              type="number"
              v-model="params2.Interval"
              clearable
            ></InputNumber>
          </FormItem>
          <FormItem label="是否打印SQL">
            <Radio-group class="publicInput" v-model="params2.isPrintSql">
              <Radio :label="1">是</Radio>
              <Radio :label="0">否</Radio>
            </Radio-group>
          </FormItem>
          <FormItem label="日志级别">
            <Select class="publicInput" v-model="params2.LogLevel">
              <Option
                v-for="item in LogsData"
                :value="item.key"
                :key="item.key"
                >{{ item.value }}</Option
              >
            </Select>
          </FormItem>
        </Form>
        <div class="btnGroup">
          <Button class="cancel" @click="getData2()">重置</Button>
          <Button type="primary" @click="saveData2()">保存</Button>
        </div>
      </div>
      <div class="service"><span class="point"></span> 服务3</div>
      <div class="secOperation">
        <Form :label-width="150" inline>
          <div class="serverTop">
            <div class="top Serverdiv">
              <div>
      <i-button @click="getData3">
        <i class="iconfont icon-refresh"></i>
        刷新
      </i-button>
      <i-button @click="showLog = true" style="margin-left: 15px;" type="primary">
        查看日志
      </i-button>
    </div>
      <div style="display: flex;align-items: center;">
      <i-switch
          v-model="isOpen2"
          @on-change="changeSwitch2"
          size="small"
          style="margin: 8px 20px 0 0px"
        ></i-switch>
      <div class="status">
        {{
          result2.serviceStatus == 10
            ? "启 用"
            : result2.serviceStatus == 11
            ? "启 用 中"
            : result2.serviceStatus == 21
            ? "禁 用 中"
            : "禁 用"
        }}
      </div>
    </div>
            </div>
            <div class="bottom Serverdiv">
              <div></div>
              <!-- <div style="" class="right">
                <div class="log" @click="showLog = true">查看日志</div>
                <i-switch
                  v-model="isOpen2"
                  @on-change="changeSwitch2"
                  size="small"
                  style="margin: 8px 0 0 0"
                ></i-switch>
              </div> -->
            </div>
          </div>
          <FormItem label="每次查询数据量">
            <InputNumber
              :min="0"
              placeholder="每次查询数据量"
              v-model="params3.SearchMax"
              clearable
            ></InputNumber>
          </FormItem>
          <FormItem :label-width="150" label="影像存储路径">
            <Input
              class="publicInput"
              placeholder="影像存储路径"
              v-model="params3.ImageSavePath"
              clearable
            ></Input>
          </FormItem>
          <FormItem label="Redis主库">
            <Select
              class="publicInput"
              v-model="params3.redisIndex"
              style="width: 180px"
            >
              <Option v-for="item in redisPrice" :value="item" :key="item">{{
                item
              }}</Option>
            </Select>
          </FormItem>
          <FormItem label="Redis明细库">
            <Select
              class="publicInput"
              v-model="params3.redisIndex2"
              style="width: 180px"
            >
              <Option v-for="item in redisPrice" :value="item" :key="item">{{
                item
              }}</Option>
            </Select>
          </FormItem>

          <FormItem label="一轮休眠时长(秒)">
            <InputNumber
              :min="0"
              placeholder="请输入"
              type="number"
              v-model="params3.Interval"
              clearable
            ></InputNumber>
          </FormItem>
          <FormItem label="是否打印SQL">
            <Radio-group class="publicInput" v-model="params3.isPrintSql">
              <Radio :label="1">是</Radio>
              <Radio :label="0">否</Radio>
            </Radio-group>
          </FormItem>
          <FormItem label="日志级别">
            <Select
              class="publicInput"
              v-model="params3.LogLevel"
              style="margin: 0 10px 8px 0; width: 180px"
            >
              <Option
                v-for="item in LogsData"
                :value="item.key"
                :key="item.key"
                >{{ item.value }}</Option
              >
            </Select>
          </FormItem>
        </Form>
        <div class="btnGroup">
          <Button class="cancel" @click="getData3()">重置</Button>
          <Button type="primary" @click="saveData3()">保存</Button>
        </div>
      </div>
    </div>
    <Modal
      v-model="showLog"
      title="影像归档服务日志"
      :footer-hide="true"
      :width="1000"
    >
      <log v-if="showLog" @close="showLog = false" :from="'imgMake'"></log>
    </Modal>
  </div>
</template>
<script>
import log from "./log.vue";
export default {
  components: { log },
  data() {
    return {
      timer: null,
      LogsData: [],
      baseData: {},
      baseData1: {},
      baseData2: {},
      oldBaseData: {},
      oldBaseData1: {},
      oldBaseData2: {},
      serviceSign: "",
      serviceSign1: "",
      serviceSign2: "",
      redisPrice: [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
      ],
      model: null,
      params1: {
        SearchMax: 0,
        ImageSavePath: "",
        redisIndex: null,
        Interval: "",
        isPrintSql: 0,
        LogLevel: null,
      },
      params2: {
        SearchMax: 0,
        ImageSavePath: "",
        redisIndex: null,
        redisIndex2: null,
        Interval: "",
        isPrintSql: 0,
        LogLevel: null,
      },
      params3: {
        SearchMax: 0,
        ImageSavePath: "",
        redisIndex: null,
        redisIndex2: null,
        Interval: "",
        isPrintSql: 0,
        LogLevel: null,
      },
      status: 10,
      isOpen: false,
      status1: 10,
      isOpen1: false,
      status2: 10,
      isOpen2: false,
      showLog: false,
      result: {},
      result1: {},
      result2: {},
      methodList: [],
    };
  },
  methods: {
    updateArchBaseConfig() {
      this.$api
        .post("/ServiceInfo/updateArchiveBaseConfig", {
          ...this.baseData,
          isPrintSql: this.baseData.isPrintSql == 1 ? true : false,
        })
        .then((res) => {
          if (res.statusCode == "200") {
            this.$Message.success("修改成功");
            this.getArchBaseConfig();
          }
        });
    },
    updateArchBase1Config() {
      this.$api
        .post("ServiceInfo/updateArchive1BaseConfig", {
          ...this.baseData1,
          isPrintSql: this.baseData1.isPrintSql == 1 ? true : false,
        })
        .then((res) => {
          if (res.statusCode == "200") {
            this.$Message.success("修改成功");
            this.getArchBase1Config();
          }
        });
    },
    updateArchBase2Config() {
      this.$api
        .post("ServiceInfo/updateArchive2BaseConfig", {
          ...this.baseData2,
          isPrintSql: this.baseData2.isPrintSql == 1 ? true : false,
        })
        .then((res) => {
          if (res.statusCode == "200") {
            this.$Message.success("修改成功");
            this.getArchBase2Config();
          }
        });
    },
    cancelEdit() {
      this.baseData = this.oldBaseData;
    },
    getArchBaseConfig() {
      this.$api.get("/ServiceInfo/getArchiveBaseConfig").then((res) => {
        //console.log('-------------------',res);
        this.baseData = res.data;
        this.baseData.isPrintSql = this.baseData.isPrintSql ? 1 : 0;
        this.oldBaseData = JSON.parse(JSON.stringify(this.baseData));
        console.log(this.baseData);
      });
    },
    getArchBase1Config() {
      this.$api.get("/ServiceInfo/getArchive1BaseConfig").then((res) => {
        //console.log('-------------------',res);
        this.baseData1 = res.data;
        this.baseData1.isPrintSql = this.baseData1.isPrintSql ? 1 : 0;
        this.oldBaseData1 = JSON.parse(JSON.stringify(this.baseData1));
        console.log(this.baseData1);
      });
    },
    getArchBase2Config() {
      this.$api.get("/ServiceInfo/getArchive2BaseConfig").then((res) => {
        //console.log('-------------------',res);
        this.baseData2 = res.data;
        this.baseData2.isPrintSql = this.baseData2.isPrintSql ? 1 : 0;
        this.oldBaseData2 = JSON.parse(JSON.stringify(this.baseData2));
        console.log(this.baseData2);
      });
    },

    changeSwitch(val) {
      // console.log(''e);
      this.isOpen = val;
      this.$api
        .post("dictionary/updateServiceStatus", {
          serviceSign: this.serviceSign1,
          serviceStatus: this.isOpen,
        })
        .then((res) => {
          if (!res) {
            this.isOpen = !this.isOpen;
            this.Status = this.result.serviceStatus;
            this.timer = setInterval(() => {
              this.getData1();
            }, 10000);
          } else {
            this.getData1();
          }
        });
    },
    changeSwitch1(val) {
      // console.log(''e);
      this.isOpen1 = val;
      this.$api
        .post("dictionary/updateServiceStatus", {
          serviceSign: this.serviceSign2,
          serviceStatus: this.isOpen1,
        })
        .then((res) => {
          console.log(res);
          if (!res) {
            this.isOpen1 = !this.isOpen1;
            this.Status1 = this.result1.serviceStatus;
            this.timer = setInterval(() => {
              this.getData2();
            }, 10000);
          } else {
            this.getData2();
          }
        });
    },
    changeSwitch2(val) {
      // console.log(''e);
      this.isOpen2 = val;
      this.$api
        .post("dictionary/updateServiceStatus", {
          serviceSign: this.serviceSign,
          serviceStatus: this.isOpen2,
        })
        .then((res) => {
          if (!res) {
            this.isOpen2 = !this.isOpen2;
            this.Status2 = this.result2.serviceStatus;
            this.timer = setInterval(() => {
              this.getData3();
            }, 10000);
          } else {
            this.getData3();
          }
        });
    },
    getData1() {
      this.$api.get(`ServiceInfo/imageArchive1Config`).then((res) => {
        this.result = res.data;
        this.Status = res.data.serviceStatus;
        this.isOpen = res.data.serviceStatus === 10;
        if (this.Status !== res.data.serviceStatus) {
          clearInterval(this.timer);
        }
        this.serviceSign1 = res.data.serviceSign;
        this.params1 = Object.assign({}, JSON.parse(res.data.serviceParams));
        console.log(this.params1, 99);
        this.params1.redisIndex = this.params1.RedisJpgMain;
        console.log(this.params1);
        this.params1.isPrintSql = this.params1.isPrintSql ? 1 : 0;
        this.params1.LogLevel = parseInt(this.params1.LogLevel);
      });
    },
    getData2() {
      this.$api.get(`ServiceInfo/imageArchive2Config`).then((res) => {
        this.params2 = Object.assign({}, JSON.parse(res.data.serviceParams));
        this.result1 = res.data;
        this.Status1 = res.data.serviceStatus;
        this.isOpen1 = res.data.serviceStatus === 10;
        if (this.Status1 !== res.data.serviceStatus) {
          clearInterval(this.timer);
        }
        this.serviceSign2 = res.data.serviceSign;
        this.params2.redisIndex = this.params2.RedisMain;
        this.params2.redisIndex2 = this.params2.RedisDetails;
        this.params2.isPrintSql = this.params2.isPrintSql ? 1 : 0;
        this.params2.LogLevel = parseInt(this.params2.LogLevel);
        this.isOpen1 = res.data.serviceStatus === 10;
      });
    },
    getData3() {
      this.$api.get(`ServiceInfo/imageArchive3Config`).then((res) => {
        this.params3 = Object.assign({}, JSON.parse(res.data.serviceParams));
        this.result2 = res.data;
        this.Status2 = res.data.serviceStatus;
        this.isOpen2 = res.data.serviceStatus === 10;
        if (this.Status2 !== res.data.serviceStatus) {
          clearInterval(this.timer);
        }
        this.serviceSign = res.data.serviceSign;
        this.params3.redisIndex = this.params3.RedisMain;
        this.params3.redisIndex2 = this.params3.RedisDetails;
        this.params3.isPrintSql = this.params3.isPrintSql ? 1 : 0;
        this.params3.LogLevel = parseInt(this.params3.LogLevel);
        console.log("3", this.params3);
        this.isOpen2 = res.data.serviceStatus === 10;
      });
    },
    saveData1() {
      // this.updateArchBaseConfig()
      this.$api
        .post(
          `ServiceInfo/addOrEditIA1Config`,
          Object.assign(
            { serviceStatus: this.status, RandomDefault: 1 },
            this.params1
          )
        )
        .then((res) => {
          if (res.statusCode == 200) {
            this.$Message.success(res.msg);
          }
          this.getData1();
        });
    },
    saveData2() {
      // this.updateArchBase1Config()
      this.$api
        .post(
          `ServiceInfo/addOrEditIA2Config`,
          Object.assign(
            { serviceStatus: this.status, RandomDefault: 1 },
            this.params2
          )
        )
        .then((res) => {
          if (res.statusCode == 200) {
            this.$Message.success(res.msg);
          }
          this.getData2();
        });
    },
    saveData3() {
      // this.updateArchBase2Config()
      this.$api
        .post(
          `ServiceInfo/addOrEditIA3Config`,
          Object.assign(
            { serviceStatus: this.status, RandomDefault: 1 },
            this.params3
          )
        )
        .then((res) => {
          if (res.statusCode == 200) {
            this.$Message.success(res.msg);
          }
          this.getData3();
        });
    },
    getAllData() {
      this.getData1();
      this.getData2();
      this.getData3();
      //  this.getArchBaseConfig()
      //  this.getArchBase2Config()
      //  this.getArchBase1Config()
    },
  },
  mounted() {
    this.LogsData = this.$parent.LogsData;
    // this.getArchBaseConfig()
    this.getAllData();
  },
};
</script>
<style scoped lang="scss">
  .status {
      width: 64px !important;
      height: 64px !important;
      background: rgba(0, 168, 112, 0.1);
      border-radius: 50% !important;
      font-size: 18px;
      font-weight: 400;
      color: #00a870;
      line-height: 64px !important;
      text-align: center;
    }
.scpPage {
  color: #333;

  .secondOperation {
    display: flex;
    justify-content: space-between;

    .status {
      width: 74px;
      height: 74px;
      background: rgba(0, 168, 112, 0.1);
      border-radius: 50%;
      font-size: 18px;
      font-weight: 400;
      color: #00a870;
      line-height: 74px;
      text-align: center;
    }
  }

  .line {
    width: 4px;
    height: 18px;
    background: #338bff;
    margin: 0 8px 0 0;
  }

  .first {
    display: flex;
    justify-content: space-between;
    margin: 16px 0 12px 0;
    height: 32px;
    line-height: 32px;

    .tit {
      display: flex;
      align-items: center;
      font-size: 16px;
    }

    .log {
      width: 82px;
      text-align: center;
      background: #f2f7ff;
      border-radius: 2px;
      font-size: 14px;
      font-weight: 400;
      color: #338bff;
      cursor: pointer;
    }
  }

  .des {
    display: flex;
    border: 1px solid #e5e5e5;
    padding: 18px 12px;

    .serDes {
      margin: 0 24px 0 0;
    }

    .secondTit {
      color: #666666;
    }
  }

  .second {
    .tit {
      display: flex;
      margin: 26px 0 12px 0;
    }

    .service {
      font-size: 14px;
      font-weight: 500;
      color: #333333;
      margin: 12px 0 8px 0;
    }

    .point {
      display: inline-block;
      width: 8px;
      height: 8px;
      background-color: #333333;
      border-radius: 50%;
    }

    .secOperation {
      border: 1px solid #e5e5e5;
      padding: 12px;

      .btnGroup {
        .cancel {
          margin: 0 12px 0 90px;
        }
      }
    }
  }
}

.publicInput {
  width: 186px !important;
  box-sizing: border-box;
}

.serverTop {
  /* background-color: red; */
  padding: 0.3125rem /* 5/16 */ 35px;

  .Serverdiv {
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
  }

  .top {
    // background-color: red;
    display: flex;
    justify-content: space-between;

    .status {
      width: 84px;
      height: 40px;
      background: rgba(0, 168, 112, 0.1);
      border-radius: 20px;
      font-size: 18px;
      font-weight: 400;
      color: #00a870;
      line-height: 40px;
      text-align: center;
    }
  }

  .bottom {
    .right {
      padding: 5px 0;
      display: flex;
      justify-content: space-between;

      .log {
        height: 30px;
        line-height: 30px;
        width: 82px;
        text-align: center;
        background: #f2f7ff;
        border-radius: 2px;
        font-size: 14px;
        font-weight: 400;
        color: #338bff;
        cursor: pointer;
      }
    }
  }
}
</style>
<style>
.scpPage .ivu-form-item {
  margin-bottom: 12px;
}

.serverInfo {
  display: flex;
  justify-content: space-between;
}
</style>